module.exports = __webpack_public_path__ + "img/375x130.adc9a143.png";